import { type FeatureFlags } from '@app/store/types/features';

import { type ResourceId } from '../general';

export enum UserDataKey {
    DreamYat = 'DreamYat',
    Sidebar = 'Sidebar',
    AutoGenerateProfile = 'AutoGenerateProfile',
    PartnerAddresses = 'PartnerAddresses',
    FrontendFeatureFlags = 'FrontendFeatureFlags',
}

export interface UserData {
    id: ResourceId;
    user_id: ResourceId;
    key: UserDataKey;
    value: FeatureFlags | unknown;
    created_at: Date;
    updated_at: Date;
}

export interface MetadataContent {
    content?: string;
    name?: string;
    property?: string;
    charset?: string;
}
